import { StyledButton, StyledModal } from "@aureskonnect/react-ui";
import { ELECTRON_MODE, KIOSK_PROBLEM } from "@constants";
import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";
import { useNavigate } from "react-router";
import { ModalBody } from "reactstrap";

import { getAlertActionButtonImageSrc } from "@helpers/general";

import { FlexboxGrid } from "@components/common/FlexboxGrid";

import { kioskStore } from "@pages/Kiosk/store";

export function ErrorPage(): JSX.Element {
    const navigate = useNavigate();
    const [isTechProblemModalOpened, setisTechProblemModalOpened] =
        React.useState(true);
    const {
        project: {
            template: {
                content: { actionsButtons },
            },
        },
    } = useSnapshot(kioskStore);
    const alertImgSrc = getAlertActionButtonImageSrc(
        actionsButtons as ActionsButtonsDesignType
    );

    function handleCloseApplication() {
        console.log(
            "Electron mode detected: sending quit event to Electron API on App Crash"
        );
        (window as RendererWindow).electronAPI.sendQuitEvent();
    }

    /*
    backgroundColor: "#707070",
                            borderColor: "#707070",
                            color: "#ffffff",
    */

    return (
        <StyledModal
            className="tech-problem-modal__clz"
            centered={true}
            isOpen={isTechProblemModalOpened}
        >
            <ModalBody
                className="d-flex align-items-center justify-content-between flex-column py-5"
                style={{ gap: "30px" }}
            >
                <FlexboxGrid
                    justifyContentCentered={true}
                    alignItemsCentered={true}
                    gap="50px"
                    className="flex-column"
                >
                    <img
                        alt=""
                        src={alertImgSrc}
                        style={{
                            height: "124px",
                            width: "144px",
                            marginTop: "30px",
                        }}
                    />
                    <h2
                        className="text-uppercase text-center"
                        style={{
                            font: "normal normal bold 50px/55px Bebas Neue",
                            letterSpacing: "2px",
                            color: "#171717",
                        }}
                    >
                        {t("Please contact technical support")}
                    </h2>
                </FlexboxGrid>
                <div
                    className="d-flex flex-column align-items-center px-5"
                    style={{
                        font: "normal normal 300 30px/42px Segoe UI",
                        letterSpacing: "0.17px",
                        textAlign: "center",
                    }}
                >
                    {KIOSK_PROBLEM}
                </div>
                <FlexboxGrid
                    alignItemsCentered={true}
                    justifyContentCentered={true}
                    gap="20px"
                    className="flex-column"
                >
                    <StyledButton
                        rounded={true}
                        onClick={() => {
                            setisTechProblemModalOpened(false);
                            navigate("/");
                            location.reload();
                        }}
                        style={{
                            width: "300px",
                            height: "60px",
                            backgroundColor: "rgb(7, 125, 188)",
                            borderColor: "rgb(7, 93, 155) 100%)",
                            color: "#ffffff",
                            fontSize: "18px",
                            fontWeight: "500",
                        }}
                    >
                        {t("Relaunch App")}
                    </StyledButton>
                    {process.env.REACT_APP_MODE === ELECTRON_MODE ? (
                        <StyledButton
                            rounded={true}
                            onClick={handleCloseApplication}
                            style={{
                                width: "300px",
                                height: "60px",
                                fontSize: "18px",
                                fontWeight: "500",
                                borderRadius: "12px",
                                backgroundColor: "rgb(255, 255, 255)",
                                border: "2px solid rgb(229, 231, 235)",
                                color: "rgb(55, 65, 81)",
                                transition: "0.2s",
                            }}
                        >
                            {t("Close app")}
                        </StyledButton>
                    ) : null}
                </FlexboxGrid>
            </ModalBody>
        </StyledModal>
    );
}
